<template>
  <!-- <div v-if="orderClicked">loading</div> -->
  <div style="background: linear-gradient(135deg,rgba(174, 1, 94, 1) 1%,rgba(222, 12, 100, 1) 16%,rgba(235, 18, 89, 1) 30%,rgba(239, 82, 69, 1) 67%,rgba(244, 121, 45, 1) 83%,rgba(254, 187, 23, 1) 100%);position: fixed;bottom: 0px;width: 100%;">
    <div class="container" v-if="selected.length > 0">
      <div class="row" style="padding-top: 10px; padding-bottom: 0px">
        <div class="col-6 col-md-4 text-left" style="padding-right: 0px">
          <div style="color: white">Seat Selected</div>
          <div>
            <a class="bt" v-for="(seat, key) in selected" :key="key">{{ seat.name }} </a>
          </div>
        </div>
        <div class="col-4 col-md-4 text-center">
          <div style="color: white">Total Price</div>
          <div class="pr">{{ selectedAmount() }}</div>
        </div>
        <div class="col-2 col-md-4 text-right" style="padding-left: 0px">
          <div style="margin-top: 15px" class="disbk1">

            <a 
             style="
                padding: 10px 13px;
                color: aliceblue;
                border-radius: 3px;
                box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
                background-color: #ae015e;
                font-weight: 600;
              " @click="bookTicket">PROCEED </a>
          </div>

          <div style="margin-top: 15px" class="disno1">
            <a class="" @click="bookTicket" style="
                padding: 10px 13px;
                color: aliceblue;
                border-radius: 3px;
                box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
                background-color: #ae015e;
                font-weight: 600;
              "><i class="fa fa-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { URL } from '@/conf';
export default {
  props: {
    selected: { default: null }
  },
  data: () => ({

    notify: null,
    exist:false,
    orderClicked: false,
    waitingPg: false,
    offline:false
  }),
  methods: {
    selectedAmount() {
      let amount = 0;
      this.selected.forEach((seat) => {
        amount += seat.prc + seat.tdamt + seat.resamt;
      });
      return "Rs " + amount;
    },
    bookTicket() {
      var myshow = this.$route.params.showid
      var seats = this.selected;
      let valid = true;
      let ermsg = "<div class='text-danger'>";

      this.notify = ermsg;
      if (!valid) {
        ermsg += "</div>";
        this.notify = ermsg;
        return
      }
      this.orderClicked = true;
      axios.post(URL + "bookTicket", { showid: myshow, seats: seats }, {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        }
      }).then((response) => {
        if(response.data.result=="booked"){
          this.$emit('seatbooked', response.data.booked);
   
        }
        this.orderClicked = false;
        if (response.data.result == "offline") {
          this.offline = true;
        }
        if (response.data.result == "error") {
          this.exist = true;
          this.$emit('seatblocked');
        }
      })
    },

  },
  emits: ["seatbooked","seatblocked"]
};
</script>
